// extracted by mini-css-extract-plugin
export default {"cls1":"FocusedNav-cls1___e61e85fc0339e45ecba","cls2":"FocusedNav-cls2__f54d19403f60125f5df3 FocusedNav-cls1___e61e85fc0339e45ecba"};